module.exports = __webpack_public_path__ + "dc59e3f777144d673e4ba7846f1b5457.pdf";